'use-client';
import * as React from 'react';
import classNames from 'clsx';
import { getDataAttributes } from '@wix/editor-elements-common-utils';
import type { LoginButtonProps } from '../LoginButton.types';
import style from './style/LoginButton.scss';
import { TestIds } from './constants';

const LoginButton: React.FC<LoginButtonProps> = props => {
  const {
    id,
    className,
    isLoggedIn,
    userName,
    onLogin,
    onLogout,
    translations,
    onMouseEnter,
    onMouseLeave,
    reportBiOnClick,
  } = props;

  const actionTitle = isLoggedIn ? translations.signOut : translations.signIn;
  const memberTitle = userName ? `${translations.hello} ${userName}` : '';

  const handleClick = (event: React.MouseEvent<Element, MouseEvent>) => {
    const biLabel = isLoggedIn ? `${memberTitle} ${actionTitle}` : actionTitle;
    reportBiOnClick?.(event, biLabel);

    if (isLoggedIn) {
      onLogout(event);
    } else {
      onLogin();
    }
  };

  return (
    <div
      id={id}
      {...getDataAttributes(props)}
      className={classNames(className, style.root, {
        [style.hidden]: isLoggedIn && !userName.length,
      })}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      {isLoggedIn && (
        <div className={style.memberTitle} data-testid={TestIds.memberTitle}>
          {memberTitle}
        </div>
      )}
      <button
        className={style.actionTitle}
        onClick={handleClick}
        data-testid={TestIds.actionTitle}
      >
        {actionTitle}
      </button>
    </div>
  );
};

export default LoginButton;
